import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import Renderable from '../../../Component/Renderable';
import { Easing, Tween } from '@tweenjs/tween.js';
import {
    AwaitIterators,
    ConcatIterators,
    PlayAnimation,
} from '../AnimationHelper';
import { delay } from '../../../Utility/Task/TaskQueue';
import { tVector4 } from '../../../Utility/ArrayHelper';
import Armature from '../../../Prototype/Armature';
import { DragonbonesDefault } from './DragonbonesDefault';
import TransformComponent from 'Component/Transform';

interface IQuestItemCooldownIntroMeta {
    cooldownText: GameObject;
    timerText: GameObject;
    refresh: Armature;
}
export class QuestItemCooldownIntro extends AnimationClip<
    IQuestItemCooldownIntroMeta
> {
    public *execute(
        gameObject: GameObject,
        meta?: IQuestItemCooldownIntroMeta
    ): IterableIterator<number> {
        const containerRenderable: Renderable = gameObject.getComponent(
            Renderable
        );
        const cooldownTextRenderable: Renderable = meta.cooldownText.getComponent(
            Renderable
        );
        const cooldownTextTransform: TransformComponent = meta.cooldownText.getComponent(
            TransformComponent
        );
        const timerTextRenderable: Renderable = meta.timerText.getComponent(
            Renderable
        );
        const timerTextTransform: TransformComponent = meta.timerText.getComponent(
            TransformComponent
        );
        yield* this.startTween(this.getAlphaTween(containerRenderable, 1, 350));

        yield* AwaitIterators([
            this.startTween(this.getAlphaTween(cooldownTextRenderable, 1, 350)),
            this.startTween(
                this.getOffsetTween(cooldownTextTransform, [0, 0, 0, 0], 350)
            ),
            this.startTween(this.getAlphaTween(timerTextRenderable, 1, 550)),
            this.startTween(
                this.getOffsetTween(timerTextTransform, [0, 0, 0, 0], 550)
            ),
            this.playRefreshAnimation(meta.refresh, 0),
        ]);
    }

    private getAlphaTween(
        renderable: Renderable,
        alpha: number,
        duration: number = 250,
        easing: (k: number) => number = Easing.Exponential.InOut
    ): Tween {
        return this.getTween(renderable)
            .to({ alpha }, duration)
            .easing(easing);
    }
    private getOffsetTween(
        transform: TransformComponent,
        offsets: tVector4,
        duration: number = 250,
        easing: (k: number) => number = Easing.Quadratic.Out
    ): Tween {
        return this.getTween(transform)
            .to(
                {
                    offsetX1: offsets[0],
                    offsetY1: offsets[1],
                    offsetX2: offsets[2],
                    offsetY2: offsets[3],
                },
                duration
            )
            .easing(easing);
    }
    private *playRefreshAnimation(
        gameObject: Armature,
        initialDelay: number
    ): IterableIterator<number> {
        const renderable: Renderable = gameObject.getComponent(Renderable);
        yield* delay(initialDelay);
        yield* AwaitIterators([
            PlayAnimation(
                new DragonbonesDefault(gameObject, {
                    playTimes: 1,
                })
            ),
            this.startTween(this.getAlphaTween(renderable, 1, 50)),
        ]);
    }
}
